import React from "react";
import styles from "./calculator.module.css";
import InvestmentDetails from "./InvestmentDetails/InvestmentDetails";
// import DetailGraph from "./DetailedBreakdown/DetailedBreakDown";
// import KnowledgeHub from "./KnowledgeHub/KnowledgeHub";

const Itc = () => {
  return (
    <div className={styles.container}>
      <div className={styles.breadCrumb}>
        <span class="material-symbols-rounded">chevron_left</span>
        <h1>Income Tax Calculator</h1>
      </div>

      <InvestmentDetails />

      {/* <DetailGraph />

      <KnowledgeHub /> */}
    </div>
  );
};

export default Itc;
